import { Col, Row } from "antd";
import React, { Component } from "react";
import CardMaterial from "../../../materials/CardMaterial";
import ButtonComponent from "../../../materials/ButtonMaterial";

interface IProps {
  getDetailDocument: any;
  getComplaintProcess: any;
  getIdComplaint: any;
  isLoading: boolean;
  handleDownload: () => void;
}

export default class DataWaybillComponent extends Component<IProps> {
  render() {
    const detailDocumentValue =
      this.props.getDetailDocument === null ? "" : this.props.getDetailDocument;

    const address =
      detailDocumentValue?.shipToAddress === null ||
      detailDocumentValue?.shipToAddress === undefined
        ? ""
        : `${Object.values(JSON.parse(detailDocumentValue?.shipToAddress)).join(
            " "
          )}`;
    const renderData = (label: any, content: any) => {
      return (
        <>
          <Col span={6}>
            <div className="detailLabelDataComplaint">
              <span>{label}</span>
            </div>
          </Col>
          <Col span={18}>
            <div className="detailValueDataComplaint">
              <span style={{ wordWrap: "break-word" }}>
                {": " + content === null || content === undefined
                  ? "-"
                  : content}
              </span>
            </div>
          </Col>
        </>
      );
    };
    const showDownloadButton =
      this.props.getComplaintProcess === "detailComplaint" ||
      this.props.getComplaintProcess === "updateComplaint";

    return (
      <div
        className={
          this.props.getComplaintProcess === "detailComplaint" ||
          this.props.getComplaintProcess === "updateComplaint"
            ? "spacingCardComplaint"
            : ""
        }
      >
        <CardMaterial
          className={"cardComplaintForm"}
          extra={
            showDownloadButton ? (
              <ButtonComponent
                className={"btnDownloadInvestigasi"}
                loading={this.props.isLoading}
                disabled={!this.props.getIdComplaint}
                onClick={this.props.handleDownload}
              >
                Download
              </ButtonComponent>
            ) : (
              ""
            )
          }
          title={<span className={"titleCardComplaintForm"}>Data Waybill</span>}
          style={{}}
          content={
            <div>
              <Row>
                {renderData("Waybill", detailDocumentValue?.waybillCode)}
                {renderData("Tanggal Cycle", detailDocumentValue?.cycle)}
                {renderData("Barcode", detailDocumentValue?.barcode)}
                {renderData("Alamat", address)}
                {renderData("Nama Pemilik", detailDocumentValue?.shipToName)}
                {renderData(
                  "No Telp",
                  detailDocumentValue?.shipToPhoneCustomers === null ||
                    detailDocumentValue?.shipToPhoneCustomers === ""
                    ? "-"
                    : detailDocumentValue?.shipToPhoneCustomers
                )}
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
